module.exports = require("ngx-bootstrap/positioning");